import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ReportStatus;
(function (ReportStatus) {
    // CLICK = 'CLICK',
    ReportStatus["LEAD"] = "LEAD";
    ReportStatus["FTD"] = "FTD";
    ReportStatus["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ReportStatus["REGISTRATION_FAILED"] = "REGISTRATION_FAILED";
    ReportStatus["ACCEPTED"] = "ACCEPTED";
})(ReportStatus || (ReportStatus = {}));
export const ReportStatusMap = new Map([
    // [ReportStatus.CLICK, 'Global.Options.ReportStatus.CLICK'],
    [ReportStatus.LEAD, 'Global.Options.ReportStatus.LEAD'],
    [ReportStatus.FTD, 'Global.Options.ReportStatus.FTD'],
    [ReportStatus.VALIDATION_FAILED, 'Global.Options.ReportStatus.VALIDATION_FAILED'],
    [ReportStatus.REGISTRATION_FAILED, 'Global.Options.ReportStatus.REGISTRATION_FAILED'],
    [ReportStatus.ACCEPTED, 'Global.Options.ReportStatus.ACCEPTED'],
]);
let ReportStatusService = class ReportStatusService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ReportStatusMap;
    }
    list() {
        return this._data;
    }
    get(status) {
        const s = this._data.get(status);
        return s ? this._translate.instant(s) : s;
    }
};
ReportStatusService.ctorParameters = () => [
    { type: TranslateService }
];
ReportStatusService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ReportStatusService);
export { ReportStatusService };
